import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/acms/devices',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/acms/device/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/acms/devices/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/acms/devices',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/acms/devices/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/acms/devices/${id}`,
      method: 'delete',
  })
}
